import {getExamStepPosition} from 'presentation/modules/booking/exam/utils/getExamStepPosition';
import {getHealthStepPosition} from 'presentation/modules/booking/health/utils/getHealthStepPosition';

import {getOdontoStepPosition} from 'presentation/modules/booking/odonto/utils/getOdontoStepPosition';

import {GetStepParams} from './types';
import {FlowEnum} from '../../constants/flowEnum';
import {getTelehealthStepPosition} from 'presentation/modules/booking/telehealth/utils/getTelehealthStepPosition';

const getStepPosition = ({flowType, isManualLocation = false}: GetStepParams) => {
	const isExamFlow = flowType === FlowEnum.EXAM;
	const isTelehealthFlow = flowType === FlowEnum.TELEHEALTH;
	const isOdontoFlow = flowType === FlowEnum.ODONTO;

	if (isExamFlow) {
		return getExamStepPosition({isManualLocation});
	}

	if (isTelehealthFlow) {
		return getTelehealthStepPosition();
	}

	if (isOdontoFlow) {
		return getOdontoStepPosition({isManualLocation});
	}

	return getHealthStepPosition({isManualLocation});
};

export {getStepPosition};
